import React, { useState } from "react";
import Form from "olive-react-myoneui/lib/Form";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import { useTranslation } from "react-i18next";
import { eyeClosedIcon, eyeOpenedIcon } from "../../../constants/icons";
import { Button } from "olive-react-myoneui";
import { changePassword } from "../../../../api/afterLogin/learners";
import { useSelector } from "react-redux";
import { Toast, ToastInfo } from "olive-react-myoneui";

const ProfilePasswordUpdate = () => {
  const configData = useSelector((state) => state.config);
  const { t } = useTranslation();

  const [input, setInput] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    password: false,
    confirmPassword: false,
  });

  const [showPasswordUpdate, setShowPasswordUpdate] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [showPasswordErrorMessage, setShowPasswordErrorMessage] = useState("");

  const validatePassword = (password) => {
    const strongPasswordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!password) {
      return t("Please provide new password");
    } else if (!strongPasswordRegex.test(password)) {
      return t("Password must include 8 characters uppercase number special");
    }
    return "";
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "password") {
      const errorMsg = validatePassword(value);
      setError((prev) => ({
        ...prev,
        password: errorMsg,
        confirmPassword:
          input.confirmPassword && value !== input.confirmPassword
            ? t("Password and Confirm Password did not match")
            : "",
      }));
    }

    if (name === "confirmPassword") {
      setError((prev) => ({
        ...prev,
        confirmPassword:
          value !== input.password
            ? t("Password and Confirm Password did not match")
            : "",
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === "password") {
      setError((prev) => ({
        ...prev,
        password: validatePassword(value),
      }));
    }
    if (name === "confirmPassword") {
      setError((prev) => ({
        ...prev,
        confirmPassword:
          value !== input.password
            ? t("Password and Confirm Password did not match")
            : "",
      }));
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { oldPassword, password, confirmPassword } = input;
    const postParams = {
      current_password: oldPassword,
      new_password: password,
      confirm_password: confirmPassword,
    };
    const response = await changePassword(configData.access_token, postParams);
    if (response.status == 200) {
      setShowPasswordError(false);
      setShowPasswordUpdate(true);
      setInput({ oldPassword: "", password: "", confirmPassword: "" });
    } else {
      setShowPasswordUpdate(false);
      setShowPasswordError(true);
      setShowPasswordErrorMessage(response.message);
    }
  };

  return (
    <>
      <Form
        className="col-xl-12"
        autoComplete="off"
        noValidate
        onSubmit={handleSubmit}
      >
        <Row>
          <div
            style={{ display: showPasswordUpdate ? "block" : "none" }}
          >
            <Toast variant="primary" className="mb-2 mt-2">
              <Toast.Body>
                <ToastInfo toastDescription="Password has been changed successfully." />
                <div className="action-wrapper">
                  <Button
                    variant="primary"
                    type="button"
                    size="sm"
                    className="btn-round bg-primary-fade"
                    aria-label="Close"
                    onClick={() => setShowPasswordUpdate(false)}
                  >
                    Close
                  </Button>
                </div>
              </Toast.Body>
            </Toast>
          </div>

          <div
            style={{ display: showPasswordError ? "block" : "none" }}
          >
            <Toast variant="error" className="mb-2 mt-2">
              <Toast.Body>
                <ToastInfo toastDescription={showPasswordErrorMessage} />
                <div className="action-wrapper">
                  <Button
                    variant="error"
                    type="button"
                    size="sm"
                    className="btn-round bg-orange-fade text-white"
                    aria-label="Close"
                    onClick={() => setShowPasswordError(false)}
                  >
                    Close
                  </Button>
                </div>
              </Toast.Body>
            </Toast>
          </div>
          <Col xl="12">
            <div className="update-password">
              <Form.Group
                className="position-relative mb-4 myk__stu-password-group "
                controlId="currentPassword"
              >
                <Form.Label>{t("Current password")}</Form.Label>
                <Form.Control
                  type={showPassword.oldPassword ? "text" : "password"}
                  name="oldPassword"
                  placeholder={t("Current password")}
                  value={input.oldPassword}
                  onChange={handleInputChange}
                  required
                />
                <span
                  className="btn-password-eye"
                  role="button"
                  onClick={() => togglePasswordVisibility("oldPassword")}
                >
                  {showPassword.oldPassword ? eyeOpenedIcon : eyeClosedIcon}
                </span>
                {error.oldPassword && (
                  <Form.Control.Feedback type="invalid" className="d-block">
                    {error.oldPassword}
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group
                className="position-relative mb-4 myk__stu-password-group"
                controlId="password"
              >
                <Form.Label>{t("Enter new password")}</Form.Label>
                <Form.Control
                  type={showPassword.password ? "text" : "password"}
                  name="password"
                  placeholder={t("Enter new password")}
                  value={input.password}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  required
                />
                <span
                  className="btn-password-eye"
                  role="button"
                  onClick={() => togglePasswordVisibility("password")}
                >
                  {showPassword.password ? eyeOpenedIcon : eyeClosedIcon}
                </span>
                {error.password && (
                  <Form.Control.Feedback type="invalid" className="d-block">
                    {error.password}
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group
                className="position-relative mb-4 myk__stu-password-group"
                controlId="confirmPassword"
              >
                <Form.Label>{t("Confirm new password")}</Form.Label>
                <Form.Control
                  type={showPassword.confirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder={t("Confirm new password")}
                  value={input.confirmPassword}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  required
                />
                <span
                  className="btn-password-eye"
                  role="button"
                  onClick={() => togglePasswordVisibility("confirmPassword")}
                >
                  {showPassword.confirmPassword ? eyeOpenedIcon : eyeClosedIcon}
                </span>
                {error.confirmPassword && (
                  <Form.Control.Feedback type="invalid" className="d-block">
                    {error.confirmPassword}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </div>
          </Col>
        </Row>
        <div className="action-btns text-end">
          <Button variant="default">Cancel</Button>
          <Button variant="primary" type="submit">
            Update password
          </Button>
        </div>
      </Form>
    </>
  );
};

export default ProfilePasswordUpdate;
